export const skipTrackingOptions = [
    {
        label: 'Property Address',
        required: true,
        message: 'Please fill Property Address',
        name: 'propaddres',
        alias: [
            'Property address',
            'Property Address',
            'Property Addess',
            'property_address',
            'property address',
            'propaddress',
            'SiteAddr',
            'propaddres',
            'Full Site Address',
            'property address',
        ],
    },
    {
        label: 'Property City',
        message: 'Please fill Property City',
        required: true,
        name: 'propcity',
        alias: [
            'Property city',
            'Property City',
            'property_city',
            'propcity',
            'SiteCity',
            'property_address_city',
            'Site Address City',
            'property_city',
            'property city',
        ],
    },
    {
        label: 'Property State',
        required: false,
        message: 'Please fill Property State',
        name: 'propst',
        alias: [
            'Property state',
            'Property St',
            'property_st',
            'Property State',
            'propst',
            'SiteState',
            'property_address_state',
            'Site Address State',
            'property_state',
            'property_st',
            'property state',
        ],
    },
    {
        label: 'Property Zip',
        required: false,
        message: 'Please fill Property Zip',
        name: 'propzip',
        alias: [
            'Property zip',
            'Property Zip',
            'property_zip',
            'propzip',
            'SiteZip',
            'property_address_zip',
            'Site Address Zip',
            'property_zip',
            'property zipcode',
            'property zip',
        ],
    },
    {
        label: 'First Name or Full Name',
        required: true,
        message: 'Please fill First Name or Full Name',
        name: 'first',
        alias: [
            'First Name',
            "Owner's First Name",
            'first_name',
            'firstname',
            'first',
            'Owner1NameFirst',
            'OWNER 1 FIRST NAME',
            'owner_firstname',
            'owner first name',
            'first name',
        ],
    },
    {
        label: 'Last Name',
        required: false,
        message: 'Please fill Last Name',
        name: 'last',
        alias: [
            'Last Name',
            'last_name',
            'lastname',
            "Owner's Last Name",
            'last',
            'Owner1NameLast',
            'OWNER 1 LAST NAME',
            'owner_lastname',
            'owner last name',
            'last name',
        ],
    },
    {
        label: 'Mailing Address',
        required: true,
        message: 'Please fill Mailing Address',
        name: 'address',
        alias: [
            'Mailing address',
            'Mailing Address',
            'address',
            'mailing_address',
            'mailing address',
            'mailaddress',
            'Mail Address',
            'MailAddr',
            'Mailing Addresses 1',
            'owner_address',
            'Mailing_Address',
            'mail_address',
        ],
    },
    {
        label: 'Mailing City',
        required: true,
        message: 'Please fill Mailing City',
        name: 'city',
        alias: [
            'Mailing city',
            'city',
            'Mailing City',
            'mailing_city',
            'mailcity',
            'Mail City',
            'MailCity',
            'MailingCity',
            'owner_city',
            'Mailing_City',
            'mail_city',
            'mailing city',
        ],
    },
    {
        label: 'Mailing State',
        required: true,
        message: 'Please fill Mailing State',
        name: 'st',
        alias: [
            'Mailing state',
            'Mailing St',
            'mailing_st',
            'mailst',
            'st',
            'state',
            'Mailing State',
            'Mail State',
            'MailState',
            'MailingState',
            'owner_state',
            'Mailing_State',
            'Mailing_St',
            'mail_state',
            'mailing state',
        ],
    },
    {
        label: 'Mailing Zip',
        required: true,
        message: 'Please fill Mailing Zip',
        name: 'zip',
        alias: [
            'Mailing zip',
            'Mail Zip',
            'zip',
            'MailZip',
            'Mailing Zip',
            'MailingZip',
            'owner_zip',
            'Mailing_Zip',
            'Mailing',
            'ZipCode',
            'Mailing_Zipcode',
            'mail_zip_code',
            'mailing zip',
        ],
    },
]
